import { faCoffee } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import React from 'react'
import { Outlet } from 'react-router-dom'
import MobileNavBar from '../Home/Components/MobileNavBar'
import NavBar from '../Home/Components/NavBar'

const PlayGroundIndex = () => {
    return (
        <div>
            <div className="sticky top-0 z-50">
                <NavBar />
                <MobileNavBar />
            </div>

            <div className='text-3xl text-orange-400 font-semibold tracking-widest w-full text-center pt-5 drop-shadow-md uppercase underline'>play ground</div>
            <div className='text-xl text-emerald-500 font-light tracking-widest w-full text-center pb-5 pt-2 drop-shadow-md capitalize'>hey mom, i'm cooking something new! <FontAwesomeIcon icon={faCoffee} /></div>

            <div className="flex lg:px-5 xl:px-10 px-2">
                <div className='w-full'>
                    <Outlet />
                </div>

            </div>
        </div>
    )
}

export default PlayGroundIndex